import { DateFormat, Formats } from '@/filters/date-filter';
import {BaseOrder, OrderPosting, PostingOrder, CandidatePackagePostingOrder, IsCandidatePostingOrderArray} from '@/views/admin-billing/admin-billing-types';
import moment from 'moment';
import {calcVat} from "@/functions/calc-functions";

export const isOrderActive = (order: PostingOrder) => moment(order.expires).isAfter(moment());

export const billingDateFormat = (date: Parameters<typeof DateFormat>[0]) => DateFormat(date, Formats.DateOnly);

export const sumOrdersDates = (orders: PostingOrder[]) => orders.reduce((x, y) => x + y.days, 0);

export const getDateDifference = (x: string, y: string) => moment(y).valueOf() - moment(x).valueOf();

export const getSortedOrders = <T extends PostingOrder | CandidatePackagePostingOrder>(orders: T[], earliest = true) =>
	[...orders].sort((x, y) => earliest ? getDateDifference(y.starts, x.starts) : getDateDifference(x.starts, y.starts))[0];

export const getPostingInfo = (postingOrder: PostingOrder | CandidatePackagePostingOrder, posting: OrderPosting) => `${posting.place} - ${postingOrder.title}`;

export const getOrderPeriod = (order: PostingOrder) => `${billingDateFormat(order.starts)} -- ${billingDateFormat(order.expires)}`;

export const getOrdersPeriod = (orders: (PostingOrder[]) | (CandidatePackagePostingOrder[])) => {
	
  if(IsCandidatePostingOrderArray(orders)) {
    const startDate = billingDateFormat(getSortedOrders(orders).starts);

    return startDate
  }

	const startDate = billingDateFormat(getSortedOrders(orders).starts);

	const endDate = billingDateFormat(getSortedOrders(orders, false).expires);

	return `${startDate} -- ${endDate}`;
};

export const getOrdersTotal = (orders: BaseOrder[], vat: number) => orders.reduce((x, y) => x + y.currentDue + calcVat(y.currentDue, vat), 0);

export const formatPrice = (price: number) => new Intl.NumberFormat('en-US').formatToParts(price).filter(x => x.type === 'integer').map(x => x.value).join(' ');
